export * from '@devstroupe/services/confirmation/public-api';
